export function resolverValor(estructura, ruta) {
  const partes = ruta.split('.')
  let valor = estructura

  for (const parte of partes) {
    if (valor == null || typeof valor !== 'object') return ''
    valor = valor[parte]
  }

  return valor ?? ''
}
